/*
 * @Descripttion:
 * @version: 2.0.0.0
 * @Author: ysanyu
 * @Date: 2020-08-22 23:35:47
 * @LastEditors: ysanyu
 * @LastEditTime: 2020-10-11 21:44:11
 */

const appInfo = {
  // appid: 'wxe1acd2a4170297cd',
  appid: 'wxcf02a1dce224de91',
  scope: 'snsapi_base',
  state: 'spdr1234',
  responseType: 'code'
}

// 高德 AK 已迁移至后端统一地理位置服务，前端不再持有任何高德密钥
export const cryptoKey = 'o58.topAAABBBZZZ' // 16位密钥
export const ivSet = 'qcwp'
export const loginUrl = (redirectUri) => {
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appInfo.appid}&redirect_uri=${redirectUri}&response_type=${appInfo.responseType}&scope=${appInfo.scope}&state=${appInfo.state}#wechat_redirect`
}

